"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coordinates = exports.CityDTO = void 0;
class CityDTO {
}
exports.CityDTO = CityDTO;
class Coordinates {
}
exports.Coordinates = Coordinates;
//# sourceMappingURL=GeoIp.js.map